import propertyApiService from "@/services/propertyApiService";
import announcementApiService from "@/services/announcementApiService";
import store from "@/store/store";

export default ({
    state: {
        propertyInfo:"",
        configurationInfo: "",
        singleSSID: "",
        isPortalAllowed: false,
        isTenantSetDpsk: false,
        loginText: "",
        isAnnouncementPresent: false
    },
    mutations: {
        SET_PROPERTY_INFO(state, propertyJson) {
            state.propertyInfo = propertyJson
            if(propertyJson !== undefined){
                if(propertyJson.ssids !== undefined && propertyJson.ssids.length === 1){
                    state.singleSSID =  propertyJson.ssids[0].trim();
                }
                if(propertyJson.tenantPortalAnnouncements !== undefined 
                    && propertyJson.tenantPortalAnnouncements !== '' 
                    && !propertyJson.multipleAnnouncementsAllowed){
                  state.isAnnouncementPresent = true;
                }
            }
        },
        SET_PROPERTY_CONFIGURATION(state, configurationJson) {
            state.configurationInfo = configurationJson;
            state.isTenantSetDpsk = configurationJson.tenantSetDpsk
        },
        SET_ACCESS_INFORMATION(state, accessJson){
            state.isPortalAllowed = accessJson.portalAllowed
            state.loginText= accessJson.loginText
        },
        SET_ANNOUNCEMENT_CONFIGURATION(state, announcementJson) {
            if (announcementJson.totalElements > 0) {
                state.isAnnouncementPresent = true;
            } 
        }
    },  
    actions: {
        loadPropertyInfo({commit}) {
            if(store.getters.getIsLoggedIn) {
                propertyApiService.getProperty().then(result => {
                    commit('SET_PROPERTY_INFO', result)
                }, error => {
                    console.error(error);
                });
            }
        },
        loadPropertyConfigurationInfo({commit}) {
            if(store.getters.getIsLoggedIn) {
                propertyApiService.getPropertyUiConfiguration().then(result => {
                    commit('SET_PROPERTY_CONFIGURATION', result)
                }, error => {
                    console.error(error);
                });
            }
        },
        loadAnnouncements({commit}) {
            if(store.getters.getIsLoggedIn) {
                announcementApiService.getAnnouncements().then(result => {
                    commit('SET_ANNOUNCEMENT_CONFIGURATION', result)
                }, error => {
                    console.error(error);
                });
            }
        }
    },
    getters: {
        getPropertyInfo(state) { return state.propertyInfo; },
        getPropertyConfigurationInfo(state) {  return state.configurationInfo; },
        getPropertySingleSSID(state){  return state.singleSSID; },
        getLoginText(state){ return state.loginText; },
        getIsPortalAllowed(state){ return state.isPortalAllowed; },
        getIsTenantSetSecret(state) {return state.isTenantSetDpsk},
        isLinkedIdentityAllowed(state) {
            return Object.hasOwn(state.propertyInfo, 'linkedIdentityAllowed') && state.propertyInfo.linkedIdentityAllowed
        },
        isDpskPassphraseLengthEnforced(state) {
            return Object.hasOwn(state.propertyInfo, 'dpskPassphraseLengthEnforced') && state.propertyInfo.dpskPassphraseLengthEnforced
        },
        getPassphraseMinLength(state) {
            return Object.hasOwn(state.propertyInfo, 'passphraseMinLength') ? state.propertyInfo.passphraseMinLength : 8
        },
        isAnnouncementPresent(state) { return state.isAnnouncementPresent; },
        isMultipleAnnouncementAllowed(state) { 
            return Object.hasOwn(state.propertyInfo, 'multipleAnnouncementsAllowed') && state.propertyInfo.multipleAnnouncementsAllowed; 
        },
        isUpdateClientAliasAllowed(state) {
            return Object.hasOwn(state.propertyInfo, 'updateClientAliasAllowed') && state.propertyInfo.updateClientAliasAllowed
        },
        nuvo2026R1LogoToggle(state) {
            return Object.hasOwn(state.propertyInfo, 'nuvo2026R1LogoToggle') && state.propertyInfo.nuvo2026R1LogoToggle
        }
    }
})
